export default {
    originalImageKey: 'ai/input/depth-map/',
    resultImageKey: 'ai/export/depth-map/',
    historyListType: 8,
    freeLimitType: 'depth-map',
    currentMenuName: '3d-photo-animation',
};
